import { Outlet } from 'react-router-dom';
import { isEmbeddedInSucceed } from '@/utils/cp-context';
import { PageFooterProvider, usePageFooter } from '@/context';
import {
  staffLayoutStyle,
  staffLayoutStyleEmbedded,
  staffMainContentStyle,
  staffMainStyle,
  staffActionBarSlotStyle,
} from './staff-layout.styles';

function StaffLayoutInner() {
  const layoutStyle = isEmbeddedInSucceed() ? staffLayoutStyleEmbedded : staffLayoutStyle;
  const { footerNode } = usePageFooter();
  return (
    <div className="staff-layout" style={layoutStyle}>
      <header className="staff-header">
        <nav>{/* Staff navigation will go here */}</nav>
      </header>
      <main className="staff-main" style={staffMainStyle}>
        <div className="staff-main-content" style={staffMainContentStyle}>
          <Outlet />
        </div>
      </main>
      {footerNode && (
        <div className="staff-action-bar-slot" style={staffActionBarSlotStyle}>
          {footerNode}
        </div>
      )}
    </div>
  );
}

export function StaffLayout() {
  return (
    <PageFooterProvider>
      <StaffLayoutInner />
    </PageFooterProvider>
  );
}
